<template>
  <v-container class="persion-edit-page" fluid tag="section">
      <base-material-dialog
        title='审计结算'
        :dialog="item.show"
        @on-dialog-change='dialogChange'
        persistent
        max-width='400'
      >
      <template v-slot:content>
        <v-card class="px-5 py-5" elevation='0'>
          <v-form ref="form" lazy-validation>
            <v-row>
              <v-col cols="12">
                <v-text-field :rules="number" hide-details="auto" label="结算金额" outlined v-model="form.payPrice"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
               <v-col cols="12">
                <v-textarea rows="3" label="支付备注" outlined v-model="form.payRemark"></v-textarea>
              </v-col>
            </v-row>
          </v-form>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text class="text--disabled" @click='item.show = false'>
              关闭
            </v-btn>
            <v-btn color="primary" :loading="loading" @click='save'>
              保存
            </v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </base-material-dialog>
  </v-container>
</template>

<script>
  import { pay } from '@/api/order/audit.js'

  export default {
    name: 'EditPriceSettle',
    props: {
      item: {
        type: Object,
        default: () => ({
          show: false,
          data: null
        })
      }
    },
    data() {
      return {
        loading: false,
        required: [
          value => !!value || '此项为必填项!'
        ],
        number: [
          value => (/^[0-9]+(.[0-9]{1,2})?$|^(0|[1-9][0-9]*)$/.test(value) && !!value) || `必填且只能为数字`,
        ],
        form: {
          id: '',
          payPrice: ''
        }
      }
    },
    methods: {
      save () {
        if (this.$refs.form.validate()) {
          this.loading = true
          pay(this.form).then(res => {
            if (res.status === 200) {
              this.item.show = false
              this.$emit("on-load-data")
              this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
            }
            this.loading = false
          })
        }
      },
      dialogChange (val) {
        this.item.show = val
        if (val) {
          this.form.id = this.item.data.id
        } else {
          this.form.payPrice = ''
        }
      }
    },
    created() {
    },
    computed: {
      isEdit () {
        return this.item.data !== undefined
      }
    }
  }
</script>

<style lang="sass" scoped>
</style>
